import { PAYEX_URL } from 'constants/index';
import { schemas } from 'constants/schemas';
import type {
  Currency,
  Field,
  GetOffersResponse,
  GetRecurringOffersResponse,
  OfferWithIds,
  Price,
  Section,
} from 'models';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';
import { normalizeResponse } from 'utils/normalize/normalize';

import type {
  GetAllOffersPayload,
  GetRecurringOffersPayload,
  NonFxDataResponse,
} from './model';

export type OffersService = {
  getAll: (payload: GetAllOffersPayload) => Promise<GetOffersResponse>;
  getRecurringOffers: (
    payload: GetRecurringOffersPayload,
  ) => Promise<GetRecurringOffersResponse>;
  getNonFxOptions: () => Promise<NonFxDataResponse>;
};

export const offers: OffersService = {
  getAll: ({
    amount,
    country,
    recipientId,
    fingerprint,
    locale,
    recurringConfigurationId,
  }) => {
    let path = `${PAYEX_URL}/offers?amount=${amount}&country=${country}&recipient=${recipientId}&fingerprint=${fingerprint}&locale=${locale}`;
    if (recurringConfigurationId) {
      path += `&recurring_configuration_id=${recurringConfigurationId}`;
    }
    const options = {
      method: 'GET',
    };

    return fetchWithAuthentication(path, options);
  },
  getRecurringOffers: ({
    amount,
    country,
    installments,
    recipientId,
    recurringConfigurationId,
  }) => {
    let path = `${PAYEX_URL}/offers/recurring?installments=${installments}&amount=${amount}&country=${country}&recipient=${recipientId}`;

    if (recurringConfigurationId) {
      path += `&recurring_configuration_id=${recurringConfigurationId}`;
    }

    const options = {
      method: 'GET',
    };

    return fetchWithAuthentication(path, options);
  },
  getNonFxOptions: () => {
    const path = `${PAYEX_URL}/offers/non_fx_options`;
    const options = {
      method: 'GET',
    };
    return fetchWithAuthentication(path, options);
  },
};

export const normalizeOffers = (
  offers: OfferWithIds[],
): {
  entities: {
    currencies: Record<string, Currency>;
    fields: Record<string, Field>;
    offers: Record<string, OfferWithIds>;
    prices: Record<string, Price>;
    sections: Record<string, Section>;
  };
  result: string[];
} => normalizeResponse(offers, schemas.arrayOfOffers);
